import { graphql } from 'react-relay';

export const GetTasksReportQuery = graphql`
	query GetTasksReportQuery($taskQuery: InlineTasksByMetadata!, $cloudId: ID) {
		inlineTasks(tasksQuery: $taskQuery, cloudId: $cloudId) {
			inlineTasks {
				id
				taskId
				status
				dueAt
				createdAt
				assignedTo {
					accountId
					displayName
					profilePicture {
						path
					}
				}
				createdBy {
					accountId
					displayName
				}
				body {
					adf
				}
				container {
					__typename
					... on ConfluencePage {
						id
						pageId
						title
						links {
							base
							webUi
						}
						labels {
							label
							prefix
						}
						space {
							id
							spaceId
							name
							links {
								base
								webUi
							}
						}
					}
					... on ConfluenceBlogPost {
						id
						blogPostId
						title
						links {
							base
							webUi
						}
						labels {
							label
							prefix
						}
						space {
							id
							spaceId
							name
							links {
								base
								webUi
							}
						}
					}
				}
			}
			endCursor
		}
	}
`;
